import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { MilestonePhaseItemDto } from 'src/api/FiretrolApiClient';
import { useMilestoneItems } from 'src/api/queries/milestones/useMilestoneItems';

const NO_ITEMS: MilestonePhaseItemDto[] = [];

export interface IMilestonePhaseItem {
  id: string;
  title: string;
}

export interface IMilestonePhaseItemSelectorProps {
  value: MilestonePhaseItemDto | null;
  onChange?: (value: MilestonePhaseItemDto | null) => void;
  disabled?: boolean;
  jobId?: number;
}

/** @registry Select dropdown of milestone phase items for a milestone template. */
export const MilestonePhaseItemSelector: React.FC<
  IMilestonePhaseItemSelectorProps
> = ({ value, onChange, disabled, jobId }) => {
  const itemsQuery = useMilestoneItems(jobId);
  const options = itemsQuery.data ?? NO_ITEMS;
  const loading = itemsQuery.isLoading;

  const data = React.useMemo(() => {
    return options.map((item) => ({
      value: item.id,
      label: item.title,
    }));
  }, [options]);

  const handleChange = (selectedValue: string | null) => {
    if (onChange) {
      if (selectedValue) {
        const selectedItem =
          options.find((item) => item.id === selectedValue) || null;
        onChange(selectedItem);
      } else {
        onChange(null);
      }
    }
  };

  return (
    <Select
      placeholder="Select an item..."
      data={data}
      value={value?.id || null}
      onChange={handleChange}
      disabled={disabled || loading}
      clearable
      searchable
      nothingFoundMessage={loading ? 'Loading items...' : 'No items found'}
    />
  );
};
